import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Image, Link, Container } from '@chakra-ui/react'

const KeyDateLayoutTwo = ({ data, meta, theme, dataTestId, brandColor }) => {
  if (!data.length) {
    return false
  }

  const titleNode = () => {
    if (!meta.title) return false

    return (
      <Box
        as='h2'
        color={theme.sectionTitleColor}
        fontFamily='heading'
        fontSize='sectionTitle'
        fontWeight='heading'
        mb={4}
      >
        {meta.title}
      </Box>
    )
  }

  return (
    <Box
      bg={theme.backgroundColor}
      px={[2, 4, 8, 16]}
      data-testid={dataTestId}
    >
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' px={0}>
          {titleNode()}
          <Flex
            flexWrap='wrap'
            flexDirection={{xs: 'column', md: 'row' }}
            mx={-6}
            my={-6}
          >
            {data.map((keyDate, index) => {
              return (
                <Box
                  key={index}
                  px={6}
                  py={6}
                  w={['100%', '50%', '50%', '50%']}
                >
                  <Box
                    boxShadow='site'
                    bg={theme.cardBackgroundColor}
                    display='flex'
                    overflow='hidden'
                    p={4}
                    rounded='site'
                    h='100%'
                  >
                    <Box display='flex' w='100%' h='100%'>
                      <Box w='calc(100% - 4rem)'>
                        <Box
                          color={theme.textColor}
                          fontFamily='heading'
                          fontWeight='heading'
                          fontSize='heading'
                          wordBreak='break-word'
                        >
                          {keyDate.name}
                        </Box>
                        <Box
                          as='p'
                          color={theme.textColor}
                          fontFamily='body'
                          fontWeight='body'
                          fontSize='body'
                          mt={1}
                          mb={3}
                          wordBreak='break-word'
                        >
                          {keyDate.description}
                        </Box>
                        {keyDate.linkText && <Box
                          as='p'
                          fontFamily='body'
                          fontWeight='body'
                          fontSize='body'
                          mt={1}
                          mb={3}
                        >
                          <Link href={keyDate.linkUrl ? keyDate.linkUrl : '#'} isExternal={keyDate.openInNewTab} color={brandColor}>
                            {keyDate.linkText}
                          </Link>
                        </Box>}
                        <Box
                          as='p'
                          color={theme.textColor}
                          fontFamily='body'
                          fontWeight='body'
                          fontSize='body'
                          mt={1}
                          mb={3}
                        >
                          {keyDate.multiDayEvent
                            ? `${keyDate.startDate} - ${keyDate.endDate}`
                            : keyDate.startDate}
                        </Box>
                      </Box>
                      <Box d='flex' justifyContent='flex-end' w='4rem'>
                        <Image
                          alt={keyDate.name}
                          p={1}
                          rounded='site'
                          src={meta.icon}
                          boxSize={12}
                        />
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )
            })}
          </Flex>
        </Container>
      </Box>
    </Box>
  )
}

KeyDateLayoutTwo.propTypes = {
  data: PropTypes.array,
  meta: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired,
  brandColor: PropTypes.string.isRequired
}

export default KeyDateLayoutTwo
